import { CONST } from '../../const/const'
import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IEventPaymentSettingsInterface } from './event-payment-settings.interface'
import * as yup from 'yup'

// Constants
const COLLECTION = CONST.DATA.FIRESTORE.V01.COLLECTIONS.EVENT_PAYMENT_SETTINGS

class EventPaymentSettingsModel
  extends ModelBaseModel<IEventPaymentSettingsInterface>
  implements IModelBaseModel
{
  public v: IEventPaymentSettingsInterface['v']
  public id: IEventPaymentSettingsInterface['id']
  public paymentOption: IEventPaymentSettingsInterface['paymentOption']
  public allowWithoutPayment: IEventPaymentSettingsInterface['allowWithoutPayment']
  public allowCreditCardPayment: IEventPaymentSettingsInterface['allowCreditCardPayment']
  public allowACHPayment: IEventPaymentSettingsInterface['allowACHPayment']
  public allowSplitPayment: IEventPaymentSettingsInterface['allowSplitPayment']
  public allowDelayedPayment: IEventPaymentSettingsInterface['allowDelayedPayment']
  public chargeSalesTax: IEventPaymentSettingsInterface['chargeSalesTax']
  public currency: IEventPaymentSettingsInterface['currency']

  public created: IEventPaymentSettingsInterface['created']
  public modified: IEventPaymentSettingsInterface['modified']

  constructor(object?: IEventPaymentSettingsInterface) {
    super()
    this.id = object?.id ?? COLLECTION.FIELDS.ID.VALUES.DEFAULT
    this.v = object?.v ?? COLLECTION.FIELDS.VERSION.VALUES.DEFAULT
    this.paymentOption = object?.paymentOption ?? COLLECTION.FIELDS.PAYMENT_OPTION.VALUES.DEFAULT
    this.allowWithoutPayment =
      object?.allowWithoutPayment ?? COLLECTION.FIELDS.ALLOW_WITHOUT_PAYMENT.VALUES.DEFAULT
    this.allowCreditCardPayment =
      object?.allowCreditCardPayment ?? COLLECTION.FIELDS.ALLOW_CREDIT_CARD_PAYMENT.VALUES.DEFAULT
    this.allowACHPayment =
      object?.allowACHPayment ?? COLLECTION.FIELDS.ALLOW_ACH_PAYMENT.VALUES.DEFAULT
    this.allowSplitPayment =
      object?.allowSplitPayment ?? COLLECTION.FIELDS.ALLOW_SPLIT_PAYMENT.VALUES.DEFAULT
    this.allowDelayedPayment =
      object?.allowDelayedPayment ?? COLLECTION.FIELDS.ALLOW_DELAYED_PAYMENT.VALUES.DEFAULT
    this.chargeSalesTax =
      object?.chargeSalesTax ?? COLLECTION.FIELDS.CHARGE_SALES_TAX.VALUES.DEFAULT
    this.currency = object?.currency ?? COLLECTION.FIELDS.CURRENCY.VALUES.DEFAULT

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: object?.created!,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: object?.modified!,
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new EventPaymentSettingsModel({
      id: doc.id,
      ...doc.data(),
    })
  }

  static validationSchema() {
    return yup.object({
      paymentOption: yup
        .string()
        .oneOf(['LeavePricesAsIs', 'IncreaseAllPrices', 'ChargeRidersAndSpectators', null])
        .nullable(),
      allowWithoutPayment: yup.bool().required(),
      allowCreditCardPayment: yup.bool().required(),
      allowACHPayment: yup.bool().required(),
      allowSplitPayment: yup.bool().required(),
      allowDelayedPayment: yup.bool().required(),
      chargeSalesTax: yup.bool().required(),
    })
  }
}

export default EventPaymentSettingsModel
